/**
 * Mount path for the Payments (formerly Sell) page.
 *
 * `SELL_BASE_PATH_LEGACY` is kept so `Sell` can still recognize legacy
 * `/app/sell/*` URLs and forward them to the canonical `/app/payments/*`.
 */
export const SELL_BASE_PATH_LEGACY = '/app/sell'
export const SELL_BASE_PATH_REBRAND = '/app/payments'

export const useSellBasePath = (): string => SELL_BASE_PATH_REBRAND
